import { useLayoutEffect, useRef, useState } from 'react';

/**
 * Tracks whether a text element is horizontally clipped (ellipsized). Re-measures
 * on element resize so it stays correct as the container reflows.
 *
 * Exported because anything that ellipsizes text next to something pinned needs
 * the same answer, and a second copy of the measurement is how the two drift.
 */
export const useIsTextOverflowing = (text?: string) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) {
      return undefined;
    }

    const measure = () => {
      setIsOverflowing(node.scrollWidth > node.clientWidth);
    };

    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(node);
    return () => observer.disconnect();
  }, [text]);

  return { ref, isOverflowing };
};
